var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrown = function SvgCrown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73963 19.1049L2.01286 7.58228C1.84923 6.49041 3.28906 5.92314 3.93482 6.82505L5.81087 9.44529C6.23474 10.0373 7.12585 10.0373 7.54972 9.44529L11.1306 4.444C11.5544 3.852 12.4456 3.852 12.8694 4.444L16.4503 9.44529C16.8741 10.0373 17.7653 10.0373 18.1891 9.44529L20.0652 6.82505C20.7109 5.92313 22.1508 6.49041 21.9871 7.58228L20.2604 19.1049C20.1833 19.6191 19.7354 20 19.2078 20H4.79217C4.26459 20 3.81669 19.6191 3.73963 19.1049Z",
    stroke: "#292D32",
    strokeWidth: 1.5
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "crown.d613a5d3e27a765647ad7ba9d8f353a1.svg";